export const ventaHeroImage =
  "https://readdy.ai/api/search-image?query=Modern%20air%20conditioning%20equipment%20showroom%20with%20sleek%20white%20inverter%20split%20units%20mounted%20on%20clean%20minimalist%20wall%2C%20warm%20ambient%20lighting%2C%20contemporary%20interior%20design%2C%20professional%20product%20photography%2C%20neutral%20earth%20tones%20with%20subtle%20green%20accent%2C%20commercial%20HVAC%20equipment%20display&width=800&height=600&seq=venta-hero-1&orientation=landscape";

export const equipmentTypes = [
  {
    name: "Mini Split",
    subtitle: "Pared",
    description:
      "Ideal para hogares, oficinas y locales comerciales. Equipos silenciosos con tecnología Inverter que climatizan espacios de hasta 60 m² con máxima eficiencia.",
    image:
      "https://readdy.ai/api/search-image?query=Sleek%20white%20mini%20split%20air%20conditioner%20mounted%20on%20modern%20living%20room%20wall%2C%20elegant%20minimalist%20interior%2C%20soft%20warm%20natural%20lighting%2C%20professional%20product%20photography%2C%20neutral%20earth%20tones%20with%20subtle%20green%20plant%20accent%2C%20energy%20efficient%20home%20appliance&width=600&height=400&seq=venta-minisplit-1&orientation=landscape",
    icon: "ri-home-line",
  },
  {
    name: "Cassette",
    subtitle: "Techo",
    description:
      "Distribución uniforme del aire en 360° para espacios amplios como oficinas, restaurantes y salas de reuniones. Instalación empotrada que se integra al diseño del techo.",
    image:
      "https://readdy.ai/api/search-image?query=Modern%20white%20ceiling%20cassette%20air%20conditioning%20unit%20installed%20in%20contemporary%20office%20ceiling%2C%20clean%20square%20panel%2C%20elegant%20commercial%20interior%2C%20bright%20even%20lighting%2C%20professional%20architectural%20photography%2C%20neutral%20earth%20tones%2C%20energy%20efficient%20HVAC%20system&width=600&height=400&seq=venta-cassette-1&orientation=landscape",
    icon: "ri-layout-grid-line",
  },
  {
    name: "Piso-Techno",
    subtitle: "Piso-Cielo",
    description:
      "Versatilidad para instalación de piso o techo en locales con fachadas de vidrio o espacios sin pared disponible. Gran capacidad de enfriamiento.",
    image:
      "https://readdy.ai/api/search-image?query=Slim%20white%20floor%20standing%20air%20conditioning%20unit%20in%20modern%20retail%20commercial%20space%2C%20elegant%20vertical%20unit%2C%20contemporary%20interior%2C%20warm%20ambient%20lighting%2C%20professional%20product%20photography%2C%20neutral%20earth%20tones%2C%20energy%20efficient%20HVAC%20equipment&width=600&height=400&seq=venta-pisotechno-1&orientation=landscape",
    icon: "ri-building-2-line",
  },
  {
    name: "Multi Split / VRF",
    subtitle: "Proyectos grandes",
    description:
      "Un solo condensador alimenta múltiples unidades interiores. Solución eficiente para edificios, hoteles, clínicas y proyectos corporativos con control independiente por zona.",
    image:
      "https://readdy.ai/api/search-image?query=Multiple%20white%20VRF%20multi%20split%20air%20conditioning%20outdoor%20condenser%20units%20arranged%20on%20clean%20commercial%20building%20rooftop%2C%20professional%20engineering%20photography%2C%20warm%20daylight%2C%20earth%20tones%2C%20energy%20efficient%20large%20scale%20HVAC%20system&width=600&height=400&seq=venta-vrf-1&orientation=landscape",
    icon: "ri-stack-line",
  },
  {
    name: "Rooftop / Paquete",
    subtitle: "Industrial",
    description:
      "Sistemas de gran capacidad para naves industriales, bodegas y superficies comerciales. Robustos, de fácil mantenimiento y diseñados para trabajo continuo.",
    image:
      "https://readdy.ai/api/search-image?query=Industrial%20packaged%20rooftop%20air%20conditioning%20unit%20on%20commercial%20building%20roof%2C%20white%20metal%20HVAC%20equipment%2C%20professional%20engineering%20photography%2C%20warm%20natural%20daylight%2C%20earth%20tones%2C%20clean%20industrial%20setting&width=600&height=400&seq=venta-rooftop-1&orientation=landscape",
    icon: "ri-building-line",
  },
] as const;

export const equipmentFeatures = [
  {
    title: "Ahorro energético real",
    description:
      "Tecnología Inverter que ajusta la potencia según la demanda y reduce el consumo hasta en un 40% frente a equipos convencionales.",
    icon: "ri-flashlight-line",
  },
  {
    title: "Garantía de fábrica",
    description:
      "Todos los equipos incluyen garantía oficial de fábrica, respaldada por el soporte técnico especializado de SERIN.",
    icon: "ri-shield-check-line",
  },
  {
    title: "Ingenieros certificados",
    description:
      "Asesoría técnica de ingenieros con más de 35 años de experiencia para elegir el equipo ideal para tu espacio.",
    icon: "ri-award-line",
  },
  {
    title: "Entrega e instalación",
    description:
      "Coordinamos entrega, instalación profesional y puesta en marcha en Bogotá y toda Colombia, cumpliendo normas SST.",
    icon: "ri-truck-line",
  },
  {
    title: "Marcas premium",
    description:
      "Trabajamos exclusivamente con Samsung, LG, Midea, Mabe y Mirage, marcas líderes con repuestos disponibles en el país.",
    icon: "ri-verified-badge-line",
  },
  {
    title: "Opciones de pago",
    description:
      "Planes flexibles y financiación para empresas y proyectos de cualquier tamaño, adaptados a tu presupuesto.",
    icon: "ri-bank-card-line",
  },
] as const;

export const ventaBrands = [
  {
    name: "Samsung",
    logo: "https://storage.helloreaddy.io/project_files/7ab0d457-3dab-428f-ba9a-e3f3097fe185/a959756e-9bc9-4b7c-aa71-2026d7437ec5_compressed_1.webp",
    description:
      "Tecnología WindFree que enfría sin corrientes de aire molestas. Equipos Inverter con ahorro energético de hasta 77%.",
  },
  {
    name: "LG",
    logo: "https://storage.helloreaddy.io/project_files/7ab0d457-3dab-428f-ba9a-e3f3097fe185/45044b53-478e-4dd0-a46d-ed4c7703fa22_compressed_2.webp",
    description:
      "Sistemas Dual Inverter de alto rendimiento con bajo nivel de ruido y conectividad inteligente desde tu celular.",
  },
  {
    name: "Midea",
    logo: "https://storage.helloreaddy.io/project_files/7ab0d457-3dab-428f-ba9a-e3f3097fe185/14484f77-dd94-4908-a351-db2bece3cdd0_compressed_Anti-Pixelation-Image-Fix-1.webp",
    description:
      "Excelente relación precio-calidad con amplia cobertura de repuestos y servicio técnico en toda Colombia.",
  },
  {
    name: "Mabe",
    logo: "https://storage.helloreaddy.io/project_files/7ab0d457-3dab-428f-ba9a-e3f3097fe185/5106040d-92d6-4f6a-b8b7-f953604d1fec_compressed_Anti-Pixelation-Image-Fix.webp",
    description:
      "Aires acondicionados confiables con respaldo de garantía local y atención técnica especializada.",
  },
  {
    name: "Mirage",
    logo: "https://static.readdy.ai/image/ea473d33d180c87428df5c28ba90939d/e76d612938c1f27ea00ad21893d0f44e.png",
    description:
      "Equipos compactos con tecnología Inverter, filtros antibacteriales y diseño moderno para hogares y oficinas.",
  },
] as const;